import { LabelGroup } from "@dropbox/dig-components/label_group";
import { List } from "@dropbox/dig-components/list";
import { Text } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import {
  ChevronDownLine,
  ChevronRightLine,
} from "@dropbox/dig-icons/dist/mjs/assets";
import type { ReactNode } from "react";
import { memo, useEffect, useState } from "react";

interface ChatDiagnosticsViewerNodeProps {
  title?: ReactNode;
  subheader?: ReactNode;
  children?: ReactNode;
  defaultExpanded?: boolean;
  isError?: boolean;
  rightAccessory?: ReactNode;
}
export const ChatDiagnosticsViewerNode = memo(
  ({
    title,
    subheader,
    children,
    defaultExpanded = false,
    isError = false,
    rightAccessory,
  }: ChatDiagnosticsViewerNodeProps) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    useEffect(() => {
      setExpanded(defaultExpanded);
    }, [defaultExpanded]);
    return (
      <List.Item
        onClick={(e) => {
          e.stopPropagation();
          setExpanded(!expanded);
        }}
        isSelectable={!!children}
        verticalAlign="top"
        spacing="small"
        withSubList={
          expanded && children && <List paddingLeft={24}>{children}</List>
        }
      >
        <List.Accessory>
          <UIIcon
            size="small"
            src={expanded ? ChevronDownLine : ChevronRightLine}
          />
        </List.Accessory>
        <List.Content>
          <LabelGroup
            tagName="label"
            withLabel={
              <Text size="small" isBold color={isError ? "error" : "standard"}>
                {title}
              </Text>
            }
            withSubText={
              subheader ? (
                <Text size="small" color="subtle">
                  {subheader}
                </Text>
              ) : null
            }
            labelGap="0"
          />
        </List.Content>
        <List.Accessory>{rightAccessory}</List.Accessory>
      </List.Item>
    );
  },
);
ChatDiagnosticsViewerNode.displayName = "ChatDiagnosticsViewerNode";
